import React, {FC, useState} from 'react'
import {useTranslation} from '@wix/yoshi-flow-editor'
import {Image, InputDialog, SectionNotification, Text, TextButton} from 'wix-ui-tpa/cssVars'

import cardImageSrc from '../../../../assets/images/card.png'

import {cardGuaranteeNoticeDataHooks} from './constants'
import {classes} from './styles.st.css'

export type CardGuaranteeNoticeVariant = 'cardGuarantee' | 'prepayment'

interface CardGuaranteeNoticeProps {
  guestPolicy?: string | null
  variant?: CardGuaranteeNoticeVariant
}

export const CardGuaranteeNotice: FC<CardGuaranteeNoticeProps> = ({
  guestPolicy,
  variant = 'cardGuarantee',
}) => {
  const isPrepayment = variant === 'prepayment'
  const {t} = useTranslation()
  const [isPolicyOpen, setIsPolicyOpen] = useState(false)
  const hasGuestPolicy = Boolean(guestPolicy)
  const paymentPolicyTitle = t('uou-reservations.reservation-details.card-guarantee.payment-policy')
  const closeDialog = () => setIsPolicyOpen(false)

  const content = (
    <div className={classes.body}>
      <div className={classes.titleRow}>
        <Image className={classes.icon} src={cardImageSrc} alt="" width={24} height={24} />
        <Text className={classes.title} tagName="p">
          {t('uou-reservations.reservation-details.card-guarantee.title')}
        </Text>
      </div>
      {isPrepayment ? null : (
        <Text className={classes.description} tagName="p">
          {t('uou-reservations.reservation-details.card-guarantee.description')}
        </Text>
      )}
      {hasGuestPolicy ? (
        <TextButton
          className={classes.link}
          onClick={() => setIsPolicyOpen(true)}
          data-hook={cardGuaranteeNoticeDataHooks.paymentPolicyLink()}
        >
          {paymentPolicyTitle}
        </TextButton>
      ) : null}
    </div>
  )

  return (
    <>
      <div data-hook={cardGuaranteeNoticeDataHooks.root()}>
        {isPrepayment ? (
          <div className={classes.prepaymentPanel}>{content}</div>
        ) : (
          <SectionNotification type="alert" className={classes.notice}>
            <SectionNotification.Text>{content}</SectionNotification.Text>
          </SectionNotification>
        )}
      </div>
      {hasGuestPolicy ? (
        <InputDialog
          isOpen={isPolicyOpen}
          onClose={closeDialog}
          title={paymentPolicyTitle}
          closeButtonAriaLabel={t('uou-reservations.shared.modal-close-button')}
          primaryButton={{
            text: t('uou-reservations.reservation-details.terms-privacy.close'),
            onClick: closeDialog,
          }}
          forceBWTheme
          className={classes.policyDialog}
        >
          <Text tagName="p" className={classes.dialogContent}>
            {guestPolicy}
          </Text>
        </InputDialog>
      ) : null}
    </>
  )
}
